import React, {Component} from 'react'
import PaymentTermEditForm from "./form/edit.component.jsx"
import SideBar from '../common/layout/sidebar.component.jsx'

class PaymentTermNew extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
    }


    render() {
        return (
            <div>
                <PaymentTermEditForm />
            </div>
        );
    }
}

export default PaymentTermNew


// WEBPACK FOOTER //
// ./src/payment-term/new.component.jsx